import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Layout, Spin } from "antd";
import "./Step_0.css";
import Step0Form from "./Step_0_Form";

@inject("profileStore", "translationsStore", "registrationStore", "usersStore")
@observer
export default class Step_0 extends Component {
  constructor(props) {
    super(props);
    this.props.registrationStore.setPosition(1);
  }

  render() {
    return (
      <Layout hasSider={false} style={{ padding: "10px" }} className="Step_0">
        <Layout style={{ alignItems: "center", justifyContent: "center" }}>
          <Spin spinning={this.props.profileStore.inProgress} style={{ minWidth: "400px" }}>
            <Step0Form />
          </Spin>
        </Layout>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_0/Step_0.js